import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class PluginService {
  baseUrl = 'plugin';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  getAvailableContentTypes = (pluginID) => BaseService.get({ url: `${this.baseUrl}/get-available-content-types/${pluginID}` });
  getAuthorizedList = (location, ids) => BaseService.post({ url: `${this.baseUrl}/get-authorized-list/${location}`, data: ids });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  activate = (id) => BaseService.post({ url: `${this.baseUrl}/activate/${id}` });
  save = (plugin) => BaseService.post({ url: `${this.baseUrl}/save`, data: plugin });

  // Rights
  getRights = (id) => BaseService.get({ url: `${this.baseUrl}/get-rights/${id}` });
  saveRights = (id, rights) => BaseService.post({ url: `${this.baseUrl}/save-rights/${id}`, data: rights });

  //Execute Custom Actions
  executeAction = (action) => BaseService.post({ url: `${this.baseUrl}/execute-action`, data: action });
}

export default new PluginService()
